import { Stripe } from '@stripe/stripe-js';

export class CardValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CardValidationError';
  }
}

export class InvalidCardError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidCardError';
  }
}

export async function handlePaymentSetupIntent({
  stripe,
  status,
  setupIntentClientSecret,
}: {
  stripe: Stripe;
  status: string;
  setupIntentClientSecret: string;
}) {
  if (status == 'requires_action') {
    const cardSetupResponse = await stripe.confirmCardSetup(setupIntentClientSecret);
    if (cardSetupResponse.error) {
      throw new CardValidationError(cardSetupResponse.error.message ?? 'Card validation failed');
    }
  } else if (status == 'requires_payment_method') {
    const errorMessage = 'The card was not approved, please try another payment option.';
    throw new InvalidCardError(errorMessage);
  }
}
